/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * @param {string} [classes]
 * @returns {string}
 */
function withReadonlyInteractionClass(classes = '') {
    const classList = `${classes}`.split(/\s+/).filter(Boolean);

    if (!classList.includes('qti-readonlyInteraction')) {
        classList.push('qti-readonlyInteraction');
    }

    return classList.join(' ');
}

/**
 * Prepare props for readonly custom interactions.
 * @param {Object} props - interaction props
 * @returns {Object} readonly interaction props
 */
export function getReadonlyCustomInteractionProps(props) {
    const properties =
        props.properties && typeof props.properties === 'object' ? { ...props.properties } : {};

    if (
        properties.autoStart === true ||
        properties.autoStart === 'true' ||
        properties.autoStart === '1'
    ) {
        properties.autoStart = false;
    }

    return {
        ...props,
        disabled: true,
        properties: {
            ...properties,
            isReadOnlyMode: true,
            isReviewMode: true
        }
    };
}

/**
 * Prepare props for readonly media interactions.
 * @param {Object} props - interaction props
 * @returns {Object} readonly interaction props
 */
export function getReadonlyMediaInteractionProps(props) {
    return {
        ...props,
        autostart: false,
        classes: withReadonlyInteractionClass(props.classes)
    };
}

/**
 * Prepare props for readonly extended text interactions.
 * @param {Object} props - interaction props
 * @returns {Object} readonly interaction props
 */
export function getReadonlyExtendedTextInteractionProps(props) {
    return {
        ...props,
        disabled: true,
        readonly: true,
        classes: withReadonlyInteractionClass(props.classes)
    };
}
